import React from "react"
import DetailsContainer from "./DetailsContainer"
import Headline from "./Headline"
import Paragraph from "./Paragraph"
import Notification from "./Notification"
import Image from "./Image"

export default function PreparationOfRawMaterials({
  headline,
  image,
  imageHeading,
  details,
}) {
  const { paragraph1, paragraph2, paragraph3, paragraph4 } = details
  return (
    <>
      <Image
        id="preparation-of-raw-materials"
        image={image}
        imageHeading={imageHeading}
        color="#fff"
      />
      <Headline text={headline} />
      <DetailsContainer>
        <Paragraph>{paragraph1.line1}</Paragraph>
        <Paragraph>
          {paragraph2.line1}
          <br />
          {paragraph2.line2}
        </Paragraph>
        <Paragraph>{paragraph3.line1}</Paragraph>
        <Paragraph>
          {paragraph4.line1}
          <br />
          {paragraph4.line2}
          <Notification text={paragraph4.notification} />
        </Paragraph>
      </DetailsContainer>
    </>
  )
}
